import { Stack, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useContext, useEffect, useMemo } from "react";
import EmailSummaryAnswer from "../dashboard-query-answer/EmailSummaryAnswer";
import { EmailBody } from "../../../API";
import { DashboardsContext } from "../../../contexts/DashboardsContext";
import { EmailSummary } from "../../../types/search";
import ArrayUtils from "../../../utils/ArrayUtils";
import { DashboardContext } from "../../../contexts/DashboardContext";

const useStyles = makeStyles((theme) => ({
    title: {
        fontFamily: 'Poppins',
        fontSize: '1.1rem',
        fontWeight: 600,
        color: theme.palette.primary.light,
    },
}));

const EmailSummaryQuery: React.FC<{ noTitle?: boolean, onHasSummary?: (state: boolean) => void}> = ({ noTitle, onHasSummary }) => {
    const classes = useStyles();
    const { dashboard } = useContext(DashboardContext);
    const { mappedOverviewQueries } = useContext(DashboardsContext);

    const latestEmail = useMemo<(EmailBody & { summary: string })|undefined>(() => {
        const emailSummaries = mappedOverviewQueries.get(`${dashboard?.id}:Email Summaries`) as EmailSummary[];
        const emails = dashboard?.emailBodies
            ?.filter(emailBody => ['EMAIL', 'FULL_EMAIL', 'CALL'].includes(emailBody?.type || ''))
            ?.map(emailBody => ({ ...emailBody,
                summary: Array.isArray(emailSummaries) ? (emailSummaries?.find(s => s?.id === emailBody?.id)?.summary || '') : '',
            })) || [];
        const sortedItems = ArrayUtils.sortByDescending([...emails], 'createdAt');

        return sortedItems.filter((item): item is EmailBody & { summary: string } => 'summary' in item)?.[0] ?? undefined;
    }, [dashboard?.emailBodies, dashboard?.id, mappedOverviewQueries]);

    useEffect(() => {
        onHasSummary?.(!!latestEmail);
    // eslint-disable-next-line
    }, [latestEmail]);

    if (!latestEmail)
        return (<></>);

    return (<>
        <Stack spacing={1} alignItems="flex-start" width="100%">
            {!noTitle && <Typography className={classes.title}> {'Summary of communications'} </Typography>}
            <EmailSummaryAnswer content={latestEmail}  />
        </Stack>
    </>);
}

export default EmailSummaryQuery;
